// Helpers compartilhados do modulo Faturamento.
export const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

export const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;

// '2026-05-01...' -> '05/2026'
export const fmtComp = (c) => {
    const s = String(c || '').slice(0, 10);
    return s ? `${s.slice(5, 7)}/${s.slice(0, 4)}` : '';
};

// '2026-05-01...' -> 'Maio/2026'
export const fmtCompExtenso = (c) => {
    const s = String(c || '').slice(0, 10);
    const m = MESES[Number(s.slice(5, 7)) - 1];
    return m ? `${m}/${s.slice(0, 4)}` : s;
};

// Textos de confirmação das ações de faturamento (fato de negócio único — não duplicar nas telas).
export const txtRecalcular = (clienteNome) =>
    `Recalcular os valores a partir dos itens atuais e reenviar para ${clienteNome || 'o cliente'}? O prazo recomeça ao reenviar.`;
export const txtReenviarMesmo = (status, valorTotal, clienteNome) =>
    status === 'contestado'
        ? `O cliente contestou este valor. Reenviar o MESMO relatório vai cobrar ${fmtBRL(valorTotal)} automaticamente se ninguém responder dentro do prazo. Continuar?`
        : `Reenviar o mesmo relatório para ${clienteNome || 'o cliente'}?`;
export const txtFaturar = (valorTotal, clienteNome) =>
    `Faturar ${fmtBRL(valorTotal)} de ${clienteNome || 'o cliente'}?`;

export const fmtDataHora = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    if (isNaN(d)) return '—';
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

// Cores/labels das situações (compartilhado entre Central e HistoricoCliente).
export const STATUS_META = {
    aguardando: { label: 'Aguardando resposta', cls: 'bg-yellow-100 text-yellow-800' },
    vencido: { label: 'Prazo vencido', cls: 'bg-amber-100 text-amber-800' },
    expirado: { label: 'Prazo vencido (a faturar)', cls: 'bg-amber-100 text-amber-800' },
    aprovado: { label: 'Aprovado pelo cliente', cls: 'bg-blue-100 text-blue-800' },
    contestado: { label: 'Contestação', cls: 'bg-orange-100 text-orange-800' },
    erro: { label: 'Falha no envio', cls: 'bg-red-100 text-red-800' },
    faturado_aprovado: { label: 'Faturado', cls: 'bg-green-100 text-green-800' },
    faturado_auto: { label: 'Faturado pelo prazo', cls: 'bg-teal-100 text-teal-800' },
    registrado: { label: 'Registrado (interno)', cls: 'bg-gray-100 text-gray-700' },
    cancelado: { label: 'Cancelado (contrato)', cls: 'bg-zinc-200 text-zinc-700' },
};

// Os 7 contadores do panorama (NÃO inclui 'vencido', que é rótulo de linha derivado).
export const STATUS_CARDS = ['aguardando', 'aprovado', 'contestado', 'erro', 'faturado_aprovado', 'faturado_auto', 'registrado'];

// Chave de contador (faturado -> auto/aprovado). Usada nos cards.
const statusChave = (ciclo) =>
    ciclo.status === 'faturado'
        ? (String(ciclo.faturado_auto) === '1' ? 'faturado_auto' : 'faturado_aprovado')
        : ciclo.status;

// 'vencido' é rótulo consultivo (compara prazo_em com o relógio do browser); a verdade do
// vencimento/auto-faturamento é do backend.
// Situação exibida na linha: 'aguardando' vencido vira 'vencido' (rótulo derivado).
export const situacaoChave = (ciclo) => {
    if (ciclo.status === 'aguardando' && ciclo.prazo_em) {
        const prazo = new Date(ciclo.prazo_em);
        if (!isNaN(prazo) && prazo < new Date()) return 'vencido';
    }
    return statusChave(ciclo);
};

// aviso padrao do modulo: const aviso = avisoDe(setAlert);
export const avisoDe = (setAlert) => (placeholder, type = 'warning') =>
    setAlert({ visible: true, title: type === 'success' ? 'Sucesso!' : 'Atenção!', placeholder, confirm: false, type });

// input type='month' ('YYYY-MM') -> parametro de competencia da API ('YYYY-MM-01'); vazio = mes anterior.
export const compParam = (m) => (m ? `${m}-01` : undefined);

// Opções de UF do faturamento (valor enviado à API, rótulo exibido). 'outros' = fora de RS/SC/PR.
// Backend mapeia para código IBGE em resolverFiltroUf. Usado nos selects de Painel e Destinatários.
export const UFS = [['RS', 'RS'], ['SC', 'SC'], ['PR', 'PR'], ['outros', 'Outros estados']];

// Ação sugerida na linha da tabela: um verbo por situação que abre o mesmo modal seguro
// (o botão é só sinalização — a confirmação/ação de verdade continua dentro do detalhe).
// primaria=true → precisa de você (azul); false → só consulta (cinza).
export const acaoSugerida = (ciclo) => {
    switch (situacaoChave(ciclo)) {
        case 'erro': return { label: 'Reenviar', primaria: true };
        case 'contestado': return { label: 'Ver contestação', primaria: true };
        case 'vencido':
        case 'expirado':
        case 'aprovado': return { label: 'Faturar', primaria: true };
        case 'aguardando': return { label: 'Abrir', primaria: false };
        default: return { label: 'Ver', primaria: false };
    }
};

// Narrativa humana do ciclo (uma frase) — só a partir dos campos do próprio ciclo.
export const narrativaCiclo = (ciclo) => {
    const env = ciclo.enviado_em ? fmtDataHora(ciclo.enviado_em) : null;
    switch (situacaoChave(ciclo)) {
        case 'aguardando':
            return env ? `Enviado em ${env}. Aguardando o cliente responder.` : 'Pronto para enviar — ainda não foi disparado.';
        case 'vencido':
            return env ? `Enviado em ${env}. O prazo venceu sem resposta.` : 'O prazo venceu sem resposta.';
        case 'expirado':
            return 'Prazo vencido sem resposta — aguardando você faturar.';
        case 'aprovado':
            return `O cliente aprovou${ciclo.respondido_por ? ` (${ciclo.respondido_por})` : ''}${ciclo.respondido_em ? ` em ${fmtDataHora(ciclo.respondido_em)}` : ''}.`;
        case 'contestado':
            return 'O cliente contestou este relatório — veja abaixo o que ele escreveu.';
        case 'erro':
            return `O envio falhou${ciclo.erro_msg ? `: ${ciclo.erro_msg}` : ''}.`;
        case 'faturado_aprovado':
            return `Faturado${ciclo.faturado_em ? ` em ${fmtDataHora(ciclo.faturado_em)}` : ''} (aprovado pelo cliente).`;
        case 'faturado_auto':
            return `Faturado pelo prazo${ciclo.faturado_em ? ` em ${fmtDataHora(ciclo.faturado_em)}` : ''}.`;
        default:
            return '';
    }
};

// Motivo (uma linha) da ação recomendada — por que esta é a próxima coisa a fazer.
export const motivoAcao = (ciclo) => {
    switch (situacaoChave(ciclo)) {
        case 'erro': return 'O envio falhou — reenvie para o cliente.';
        case 'contestado': return 'O cliente contestou — recalcule os valores e reenvie.';
        case 'vencido':
        case 'expirado': return 'O prazo venceu sem resposta — fature ou trate.';
        case 'aprovado': return 'O cliente aprovou — pode faturar.';
        case 'aguardando': return 'No prazo — aguardando o cliente responder.';
        default: return '';
    }
};

// Classe base do "pill" (compartilhada por StatusBadge e DivergenciaBadge);
// cada badge só acrescenta suas cores.
const pillCls = (compact) => `inline-block ${compact ? 'px-2 py-0.5' : 'px-2.5 py-1'} rounded-full text-xs font-semibold`;

// Nome do contrato para exibição (Leva 2B: eixo do módulo virou cliente + contrato).
// Mesmo padrão do nº usado em SeletorContrato.jsx ("Nº <numero>"). Aceita os dois
// shapes que circulam no módulo: contrato "puro" (ClientesAtivacao/Destinatarios,
// vindo de /ativacao, campos nome/numero) e linha de ciclo (Painel/HistoricoCliente,
// vindo de /painel e /ciclosPorCliente, campos prefixados contrato_nome/contrato_numero).
export const nomeContrato = (c) => {
    const nome = c?.nome ?? c?.contrato_nome;
    const numero = c?.numero ?? c?.contrato_numero;
    return `${nome || '—'}${numero ? ` (nº ${numero})` : ''}`;
};

// Cores do status do CONTRATO (não confundir com STATUS_META, que é do CICLO de
// faturamento) — mesma paleta de src/components/Clientes/SeletorContrato.jsx.
const CONTRATO_STATUS_CLS = {
    implantacao: 'bg-sky-100 text-sky-800',
    ativo: 'bg-green-100 text-green-800',
    suspenso: 'bg-yellow-100 text-yellow-800',
    encerrado: 'bg-red-100 text-red-800',
};

export const ContratoStatusBadge = ({ status, compact = false }) => (
    <span className={`${pillCls(compact)} ${CONTRATO_STATUS_CLS[status] || 'bg-gray-100 text-gray-700'}`}>
        {status === 'implantacao' ? 'Em implantação' : (status || '—')}
    </span>
);

export const StatusBadge = ({ ciclo, compact = false }) => {
    const chave = situacaoChave(ciclo);
    return (
        <span className={`${pillCls(compact)} ${STATUS_META[chave]?.cls || 'bg-gray-100 text-gray-700'}`}>
            {STATUS_META[chave]?.label || ciclo.status}
        </span>
    );
};

// Divergência: o valor congelado difere do cálculo ao vivo (cache preenchido pela
// varredura diária). divergencia_em é o SINAL — setado só quando diverge (inclui o
// caso 'linha zerada' com total compensado, onde a diferença de total pode ser 0).
export const temDivergencia = (ciclo) => !!ciclo && ciclo.divergencia_em != null;

export const DivergenciaBadge = ({ ciclo, compact = false }) => {
    if (!temDivergencia(ciclo)) return null;
    const aoVivo = Number(ciclo.divergencia_ao_vivo || 0);
    const diff = aoVivo - Number(ciclo.valor_total || 0);
    const detalhe = Math.abs(diff) >= 0.01
        ? `Ao vivo: ${fmtBRL(aoVivo)} (${diff > 0 ? '+' : ''}${fmtBRL(diff)})`
        : 'Uma linha mudou (total compensado)';
    return (
        <span title={`${detalhe} — config mudou após o envio`}
            className={`${pillCls(compact)} bg-amber-100 text-amber-800`}>
            ⚠ divergência
        </span>
    );
};
